import { useState } from "react";
import { rsvpSubmissionSchema } from "../../schemas/rsvp-schema";
import type { SectionRenderProps } from "../renderer/types";

export function RsvpSection({ data, copy, services }: SectionRenderProps) {
  const [feedback, setFeedback] = useState("");
  if (!data.rsvp.enabled) return null;
  return (
    <section className="rsvp section-inner" id="rsvp">
      <div className="section-heading">
        <p className="eyebrow">{copy.reservation}</p>
        <h2 data-editor-section="rsvp" data-editor-field="rsvp.title">{data.rsvp.title}</h2>
        <p className="section-copy" data-editor-section="rsvp" data-editor-field="rsvp.description">{data.rsvp.description}</p>
      </div>
      <form className="form-panel" onSubmit={async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const input = Object.fromEntries(new FormData(form));
        const result = rsvpSubmissionSchema.safeParse(input);
        if (!result.success) {
          setFeedback("Please complete the RSVP form.");
          return;
        }
        await services.rsvps.submit(result.data);
        setFeedback(copy.rsvpSuccess);
        form.reset();
      }}>
        <label><span>{copy.name}</span><input type="text" name="name" required /></label>
        <label><span>{copy.attendance}</span><select name="attendance" required defaultValue=""><option value="" disabled>Choose</option>{data.rsvp.attendanceOptions.map((option) => <option key={option}>{option}</option>)}</select></label>
        <label><span>{copy.guests}</span><input type="number" name="guests" min="0" max={data.rsvp.maximumGuests} defaultValue="1" required /></label>
        <button className="primary-btn dark-btn" type="submit">{copy.sendRsvp}</button>
        {feedback ? <p className="form-feedback show success" role="status">{feedback}</p> : null}
      </form>
    </section>
  );
}
